import type { TowerValue } from '../types';
import { deriveAttachmentPoints } from './attachmentPoints';
import { fromTowerValue } from './towerValueMapper';

/**
 * The attachment point of the Cowbell excess layer: the running sum of the
 * limits sitting beneath it (primary limit plus each underlying layer's limit).
 * The primary retention is a deductible and is excluded, matching how the tower
 * UI derives attachment points. An absent tower reads as zero.
 */
export function deriveExcessAttachment(
  tower: TowerValue | null | undefined
): number {
  return deriveAttachmentPoints(fromTowerValue(tower)).cowbell;
}
